module.exports = __webpack_public_path__ + "static/media/35.846cbf78.png";